import { useEffect } from 'react';
import { getBaseAdminURL } from '../urls';

const useReceiveMessage = () => {
  useEffect(() => {
    const handleParentMessage = (event: MessageEvent) => {
      if (event.origin !== getBaseAdminURL()) return;
      if (event.data.type == 'BL_DATA') {
        // console.log('BL_DATA PARENT MESSAGE', event.data.payload);
      }
    };

    window.addEventListener('message', handleParentMessage);

    return () => {
      window.removeEventListener('message', handleParentMessage);
    };
  }, []);
};

export default useReceiveMessage;
